import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addCondition: {
		id: 'servicedesk-sla-settings.metrics.metric.editable.form.conditions.condition.add-condition',
		defaultMessage: 'Add Condition',
		description: 'Text message for add condition',
	},
	addConditionAriaLabel: {
		id: 'servicedesk-sla-settings.metrics.metric.editable.form.conditions.condition.add-condition-aria-label',
		defaultMessage: 'Add {listName} condition',
		description: 'Aria label for add condition button',
	},
});
